import useAPI from '@/hooks/useAPI';
import { useQueryResponseMessage } from '@/hooks/useQueryResponseMessage';
import PersonRepository from '@/repositories/PersonRepository';

export const useSendOneTimeLoginEmail = ({
  personId,
  enabled = false
}: {
  personId: string;
  enabled?: boolean;
}) => {
  const personRepository = PersonRepository();
  const queryKey = ['sendOneTimeLoginEmail', personId];

  const queryResponse = useAPI({
    queryKey,
    queryFn: async () => {
      return await personRepository.sendOneTimeLoginEmail(personId);
    },
    enabled
  });

  const { dataUpdatedAt, isSuccess } = queryResponse;

  useQueryResponseMessage({
    dataUpdatedAt,
    isSuccess,
    queryKey,
    successMessage: 'Successfully sent one time login email'
  });

  return queryResponse;
};

export default useSendOneTimeLoginEmail;
